import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import "semantic-ui-css/semantic.min.css"
import firebase from "./firebase";
import * as fs from "./firestore";
import * as pages from "./pages";
import './App.css';
import { firestore } from "firebase";
import AppUser from "./AppUser";

enum AuthState {
    Unknown = 1,
    NotAuthenticated = 2,
    Authenticated = 3
}
interface AppState {
    authState: AuthState;
    user: AppUser|null;
    deviceState: string;
}

export default class App extends Component<{}, AppState>  {
    constructor(props: {}) {
        super(props);
        this.state = {
            authState: AuthState.Unknown,
            user: null,
            deviceState: ''
        };
    }
    componentWillMount() {
        firebase.auth().onAuthStateChanged(async user => {
            if (user) {
                const doc = await firestore().collection(fs.Collection.Users).doc(user.uid).get();
                this.setState({
                    authState: AuthState.Authenticated,
                    user: {
                        ...user,
                        ...doc.data() as fs.User
                    }
                });
            } else {
                this.setState({
                    authState: AuthState.NotAuthenticated,
                    user: null
                });
            }
        });
    }

    handleDeviceState = async (deviceState: string) => {

        this.setState( {deviceState: deviceState} );
   };

    render() {
        const { authState } = this.state;
        return (
            <Router>
                <Switch>
                    <Route exact path="/" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        if (this.state.user.role !== fs.Role.Admin) {
                            return <pages.TopPage {...props} user={this.state.user} />;
                        }
                        if (this.state.user.role === fs.Role.Admin) {
                            return <pages.AdminTopPage {...props} user={this.state.user} />;
                        }
                    }} />
                    <Route exact path="/data-list" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        return <pages.CustomerDataListPage {...props} user={this.state.user} />;
                    }} />
                    <Route exact path="/admin-data-list" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        if (this.state.user.role !== fs.Role.Admin) {
                            return <pages.NotFoundPage {...props}/>;
                        }
                        return <pages.AdminDataListPage {...props} user={this.state.user} />;
                    }} />
                    <Route exact path="/warranty-list" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        return <pages.UserWarrantyListPage {...props} user={this.state.user} />;
                    }} />
                    <Route exact path="/device-maint" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        if (this.state.deviceState == "Import") {
                            return <pages.DeviceListImportPage {...props} user={this.state.user} onsubmit={this.handleDeviceState} />;
                        }
                        if (this.state.deviceState == "List") {
                            return <pages.AdminDeviceListPage {...props} user={this.state.user} onsubmit={this.handleDeviceState} />;
                        }
                        return <pages.DeviceMaintPage {...props} user={this.state.user} onsubmit={this.handleDeviceState} />;
                    }} />
                    <Route exact path="/device-list" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        return <pages.AdminDeviceListPage {...props} user={this.state.user} onsubmit={this.handleDeviceState} />;
                    }} />
                    <Route exact path="/device-maint_navi" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        return <pages.DeviceMaintPage {...props} user={this.state.user} onsubmit={this.handleDeviceState} />;
                    }} />
                    <Route exact path="/demo-tool" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.NotAuthenticated) {
                            return <Redirect to="/login" />;
                        }
                        if (!this.state.user) {
                            throw new Error("user is null");
                        }
                        return <pages.DemoDataImportPage {...props} user={this.state.user} />;
                    }} />
                    <Route path="/login" render={props => {
                        if (authState == AuthState.Unknown) {
                            return <pages.LoadingPage {...props} />
                        }
                        if (authState == AuthState.Authenticated) {
                            return <Redirect to="/" />;
                        }
                        return <pages.LoginPage {...props} />;
                    }} />
                    <Route path="/password-reset" render={props => {
                        return <pages.PasswordResetPage {...props} />;
                    }} />
                    <Route path="/logout" component={pages.LogoutPage} />
                    <Route component={pages.NotFoundPage} />
                </Switch>
            </Router>
        );
    }
}
